import React from "react";
import UpdateImg from "../../../img/upgrade/licenseupgraded.svg"
import UpdateImgMobile from "../../../img/upgrade/licenseupgraded-mobile.svg"
import { WhyUpgrade } from "./WhyUpgrade";

interface ConvertedLicenseProps {
    email: string;
    openUpdateContactModal: () => void;
}

export function ConvertedLicense(props: ConvertedLicenseProps) {
    const { email, openUpdateContactModal } = props;

    return (
        <div className="mainContainer w-100 vstack">
            <div className="success-hero vstack w-100 p-0 position-relative">
                <div className="hero-content-wrapper d-flex flex-column flex-lg-row w-100 gap-4 gap-lg-6 align-items-center justify-content-between">
                    <div className="lead-message vstack justify-content-center">
                            <h1 className="header-light mb-3 mb-md-4">
                                Your license has been upgraded!
                            </h1>
                        <div>
                            <div className="hstack gap-3 text-start mb-3">
                                <div className="number-step align-self-start">1</div>
                                <div className="vstack gap-2">
                                    <div className="main-paragraph">
                                        The new license has been sent to {" "}
                                        <strong className="link">{email}</strong>
                                </div>
                                <button
                                    onClick={openUpdateContactModal}
                                    className="btn btn-primary rounded-pill text-white d-flex align-items-center align-self-start gap-1"
                                >
                                    Send to a different email
                                </button>
                            </div>
                        </div>
                        <div className="hstack gap-3 text-start">
                            <div className="number-step align-self-start">2</div>
                                <div className="main-paragraph">
                                    You can find upgrade instructions in the following{" "}
                                    <strong>
                                        <a
                                            href="https://ravendb.net/docs/article-page/6.0/csharp/start/installation/upgrading-to-new-version"
                                            className="link nobr"
                                        >
                                            <span className="me-1">documentation link</span>
                                            <i className="icon-newtab-icon"></i>
                                        </a>
                                    </strong>
                                </div>
                         </div>
                        </div>
                    </div>
                    <div className="success-hero-img">
                        <picture>
                            <source srcSet={UpdateImgMobile} media="(max-width: 990px)" />
                            <img src={UpdateImg} alt="License Upgraded" />
                        </picture>
                    </div>
                </div>
                <div className="text-center text-muted position-absolute bottom-0 start-50 translate-middle-x mb-4 w-100 px-3" style={{ fontSize: '12px'}}>
                    Please note that subscription adjustments, effective January 1st, 2024, apply whether you
                    upgrade now or later. <br className="d-none d-md-block"/> For your subscription, this will be applied on the next payment date.
                    We're here to offer flexible solutions.
                </div>
            </div>
            <WhyUpgrade />
        </div>
    );
}
